/**
 *
 * @author Jesus R. Nava Cruz
 * @date May 24, 2023
 * @version 1.0
 *
 */

export default {
  path: "/app/config/productos",
  name: "PRODUCTOS",
  component: () => import("@/app/views/crud/CrudSimpleView.vue"),
  meta: {
    service: () => import("@/app/services/ProductService"),
    table: () => import("@/app/components/products/ProductsTable"),
    form: () => import("@/app/components/products/ProductsForm"),
    header: {
      icono: "mdi-package",
      texto: "Productos",
      textNew: "Registrar Producto",
      textEdit: "Modificar Producto",
    },
    prm: "ND",
    requireAuth: true,
  },
};
